const experiences = [
  {
    year: "December 2018-May 2019",
    position: "Web developer intern",
    company: "Team Evionix",
    description:
      "Responsible for creating and maintaining the website using HTML, CSS, Bootstrap and Flask",
  },
  {
    year: "August 2021- June 2022",
    position: "Project Engineer - Frontend Developer",
    company: "Wipro Technologies",
    description:
      "Worked on an internal application for Apple Computers Inc.. Developed the frontend of the application using Vue, Vuex, Vue Router, Bootstrap and SCSS",
  },
  {
    year: "September 2022 - Present",
    position: "Frontend Engineer",
    company: "mambo EMM",
    description:
      "Worked on the frontend for mambo EMM application, an Android Management EMM. Was responsible for the UI/UX design and development of the app.",
    techStack:
      "Vue, Vuex, Typescript, Vue Router, Jest, Vuetify, Bootstrap, Sass/SCSS",
  },
];

export default experiences;
